import { BaseEntityModel } from '../core/abstractions/base-entity.model';

export class NotificationSettingsModel extends BaseEntityModel {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    emailNotificationsEnabled!: boolean;
    emailSchedule!: string;

    constructor(init?: Partial<NotificationSettingsModel>) {
        super();
        if (!!init) {
            Object.assign(this, init);
        }
    }
}
